module.exports = __webpack_public_path__ + "static/img/24.273b3aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/24.png
// module id = Y0yk
// module chunks = 0